// import { canNavigate } from '@layouts/plugins/casl'
import { useAuthStore } from '@core/stores/AuthStore'
import { getI18n } from '@/plugins/i18n/index'

const i18n = getI18n()

export const setupGuards = router => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  // router.beforeEach(to => {
  //   const authStore = useAuthStore()
  //   console.log("isAuthenticated", authStore.isAuthenticated)

  //   /*
  //        * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
  //        * Examples of public routes are, 404, under maintenance, etc.
  //        */
  //   if (to.meta.public) {
  //     return
  //   }



  //   /**
  //        * Check if user is logged in by checking if token & user data exists in local storage
  //        * Feel free to update this logic to suit your needs
  //        */
  //   // const isLoggedIn = !!(useCookie('userData').value && useCookie('accessToken').value)
  //   const isLoggedIn = authStore.isAuthenticated

  //   /*
  //         If user is logged in and is trying to access login like page, redirect to home
  //         else allow visiting the page
  //         (WARN: Don't allow executing further by return statement because next code will check for permissions)
  //        */
  //   if (to.meta.unauthenticatedOnly) {
  //     if (isLoggedIn) {
  //       return '/'
  //     } else {
  //       return undefined
  //     }
  //   }
  //   // if (!canNavigate(to) && to.matched.length) {
  //   if (to.matched.length) {
  //     /* eslint-disable indent */
  //           return isLoggedIn
  //               ? { name: 'not-authorized' }
  //               : {
  //                   name: 'login',
  //                   query: {
  //                       ...to.query,
  //                       to: to.fullPath !== '/' ? to.path : undefined,
  //                   },
  //               }
  //           /* eslint-enable indent */
  //   }
  // })


  // Guard against leaving the wizard without explicit confirmation from the user to avoid potential loss of changes.
  // The global boolean check is necessary as sometimes the function could be invoked twice in a row, for example,
  // when performing a redirect to the login page, should the user be unauthenticated. In this case *from.name* would
  // still be "setup-wizard".
  let leavingWizardConfirmed = false
  router.beforeEach((to, from, next) => {
    if (from.name === 'setup-wizard' && !leavingWizardConfirmed) {
      if (to.query.wizardFinished) {
        next()

        return
      }

      leavingWizardConfirmed = window.confirm(i18n.global.t('Leave setup wizard confirmation'))
      if (!leavingWizardConfirmed) {
        return
      }
    } else if (from.name !== 'setup-wizard') {
      leavingWizardConfirmed = false
    }

    next()
  })

  // eslint-disable-next-line no-unused-vars
  router.beforeResolve(async (to, from, next) => {
    // router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()

    if (to.meta.authenticatedOnly && !authStore.isAuthenticated) {
      authStore.setRedirectUrl(to.href)

      return next({ path: '/login' })
    }

    if (to.meta.unauthenticatedOnly && authStore.isAuthenticated) {
      return next({ path: '/' })
    }

    next()
  })
}
